import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';
import { OrganizerTimeslotEditionDeleteSelectedTimeslotsComponent } from '~/organizer/timeslot-edition/components/pages/delete-selected-timeslots/delete-selected-timeslots.component';
import { OrganizerTimeslotEditionGroupSizeComponent } from '~/organizer/timeslot-edition/components/pages/group-size/group-size.component';
import { OrganizerTimeslotEditionOffersComponent } from '~/organizer/timeslot-edition/components/pages/offers/offers.component';
import { OrganizerTimeslotEditionRoutingModule } from '~/organizer/timeslot-edition/timeslot-edition-routing.module';
import { ParamethorModule } from '~/paramethor/paramethor.module';

import { OrganizerTimeslotEditionDateComponent } from './components/pages/date/date.component';
import { OrganizerTimeslotEditionLiveUrlComponent } from './components/pages/live-url/live-url.component';
import { OrganizerTimeslotEditionUpdateGroupSizeForSelectedTimeslotsComponent } from './components/pages/update-group-size-for-selected-timeslots/update-group-size-for-selected-timeslots.component';
import { OrganizerTimeslotEditionUpdateLiveUrlForSelectedTimeslotsComponent } from './components/pages/update-live-url-for-selected-timeslots/update-live-url-for-selected-timeslots.component';
import { OrganizerTimeslotEditionUpdateOffersForSelectedTimeslotsComponent } from './components/pages/update-offers-for-selected-timeslots/update-offers-for-selected-timeslots.component';
import { OrganizerTimeslotEditionSharedSelectTimeslotsComponent } from './components/shared/select-timeslots/select-timeslots.component';

@NgModule({
  declarations: [
    OrganizerTimeslotEditionGroupSizeComponent,
    OrganizerTimeslotEditionOffersComponent,
    OrganizerTimeslotEditionSharedSelectTimeslotsComponent,
    OrganizerTimeslotEditionUpdateOffersForSelectedTimeslotsComponent,
    OrganizerTimeslotEditionUpdateGroupSizeForSelectedTimeslotsComponent,
    OrganizerTimeslotEditionDeleteSelectedTimeslotsComponent,
    OrganizerTimeslotEditionLiveUrlComponent,
    OrganizerTimeslotEditionUpdateLiveUrlForSelectedTimeslotsComponent,
    OrganizerTimeslotEditionDateComponent,
  ],
  imports: [
    AuthModule,
    ComponentModule,
    OrganizerSharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    OrganizerTimeslotEditionRoutingModule,
    ParamethorModule,
    CommonModule,
  ],
  providers: [],
})
export class OrganizerTimeslotEditionModule {}
